module.exports = __webpack_public_path__ + "img/pay_ali.035d104d.png";